import { render, staticRenderFns } from "./areCancell.vue?vue&type=template&id=4c27e43a&scoped=true&"
import script from "./areCancell.vue?vue&type=script&lang=js&"
export * from "./areCancell.vue?vue&type=script&lang=js&"
import style0 from "./areCancell.vue?vue&type=style&index=0&id=4c27e43a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c27e43a",
  null
  
)

export default component.exports